import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppComponentModule } from '../core/component/app-component.module';

import { MainLayoutComponent } from './main-layout/main-layout.component';
import { AccountLayoutComponent } from './account-layout/account-layout.component';

@NgModule({
  imports: [
    AppComponentModule,
    RouterModule,
  ],
  declarations: [
    MainLayoutComponent,
    AccountLayoutComponent,
  ],
  exports: [
    MainLayoutComponent,
    AccountLayoutComponent,
  ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// ./src/app/layout/layout.module.ts